<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            {{ title }}
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"/>
              </div>
              <div class="col-md-4 form-group">
                  <label>USER</label>
                  <select @change="filter_report()" v-model="filterreport.user" class="form-control m-1">
                      <option value="">Select User</option>
                      <option v-for="user in CLINIC_USERS" :value="user.id" :key="user.id">{{ user.name }}</option>
                  </select>

              </div>
            </div>
            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="filtered_array ? filtered_array : []"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dateTime)="data">
                  {{ data.item.dateCreated }}({{ data.item.time }})
                </template>
              </b-table>
              <h3 v-if="!this.Audits" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "Audit Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filtered_array: [],
      filterreport: {
        date1: "",
        user: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      title: "Users Audit Trials",
      items: [
        {
          text: "Users Audits",
          href: "#",
        },
        {
          text: "Users Audit Trials",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "actionBy.name",
          sortable: true,
          label: "USER NAME",
        },
        {
          key: "action",
          sortable: true,
          label: "ACTION",
        },
        {
          key: "dateTime",
          sortable: true,
          label: "DATE & TIME",
        },
      ],
      data: {
        name: "",
        branch_id: "",
        type: "1",
        cost: "",
        price: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      costError: "",
      editData: {
        id: "",
        name: "",
        cost: "",
        price: "",
        branch_id: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
    };
  },

  computed: {
      ...mapGetters("audits", ["Audits"]),
      ...mapGetters("users", ["CLINIC_USERS"]),

    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },
  watch: {
    Audits(newValue) {
      if (newValue.length > 0) {
        this.fill_audits();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchAudits: "audits/fetchAuditTrials",
        FetchUsers: "users/fetchUsers",
    }),
    filter_report() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let pickedUser = this.filterreport.user;
      if (startDate != "" && endDate != "") {
        this.title = `AUDIT REPORT FROM ${startDate} TO ${endDate}`;
        if (pickedUser!=""){
            this.filtered_array = this.Audits.filter((auditTrial) => {
                return auditTrial.date >= startDate && auditTrial.date <= endDate && auditTrial.actionBy.id==pickedUser;
            });
        }else {
            this.filtered_array = this.Audits.filter((auditTrial) => {
                return auditTrial.date >= startDate && auditTrial.date <= endDate;
            });
        }
      } else {
          if (pickedUser!=""){
              this.filtered_array = this.Audits.filter((auditTrial) => {
                  return auditTrial.actionBy.id==pickedUser;
              });
          }else {
              this.filtered_array = this.Audits;
          }
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    fill_audits() {
      this.filtered_array = this.Audits;
    },
  },

  created() {
    this.FetchAudits();
    this.fill_audits();
    this.FetchUsers();
  },
};
</script>

<style lang="css" scoped></style>
